// extracted by mini-css-extract-plugin
export var moon = "icon-mod--moon--2mahn";
export var sun = "icon-mod--sun--2N18v";
export var map = "icon-mod--map--2rxoX";
export var path_home = "icon-mod--path_home--AM3Is";
export var map_mandalay = "icon-mod--map_mandalay--2liD3";